import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ErrorMessageComponent } from 'app/shared/error-message/error-message.component';

@Component({
    selector: 'app-not-permitted',
    templateUrl: './not-permitted.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ErrorMessageComponent],
})
export class NotPermittedComponent { }
